import {comMapping} from '../../util/Function/comMapping.js'
export default{
	pagination:{
		pageNum: 1,
		pageSize: 50,
		total: 0,
		paginationkey:0
	},
	formlist: [{
		prop: "type",
		label: "类型",
		type: "select",
		width:"220px",
		selectval:[
			{
				label:"报表 ",
				value:"1"
			},
			{
				label:"完税凭证",
				value:"2"
			},
			{
				label:"涉税资料",
				value:"3"
			},
			{
				label: "强制弹框附注",
				value: "4"
			}
		]
	
	},{
		prop: "name",
		label: "名称",
		type: "input",
		width:"220px"
	
	},{
		prop: "description",
		label: "描述",
		type: "textarea",
		width:"380px"
	
	}], 
	searchlistzc: [
		{
			prop: "policyTitle",
			label: '标题',
			type: "input"
		},
		{
			prop: "policyType",
			label: '政策类型',
			type: "select",
			selectval: comMapping.$sszskzclx,
		},
		{
			prop: "isValid",
			label: '是否失效',
			type: "select",
			selectval: [
				{
					label: "是",
					value: "1"
				},
				{
					label: "否",
					value: "2"
				}
			],
		},
	],
	formdatazc: {
		policyTitle: "",
		isValid: "1",
		policyType: "1",
		fbDanw: "",
		policyNum: "",
		xianggxz: "",
		fabTime: "",
	},
	seezcformlist: [
		{
			prop: "policyTitle",
			label: "标题",
			type: "input",
			istosee: true
		},
		{
			prop: "policyNum",
			label: "发文字号",
			type: "input",
			istosee: true
		},
		{
			prop: "isValid",
			label: "是否失效",
			type: "radio",
			radioval: [
				{
					label: "是",
					value: "1"
				},
				{
					label: "否",
					value: "2"
				}
			],
			istosee: true
		},
		{
			prop: "xianggxz",
			label: "相关税种",
			type: "input",
			istosee: true
		},
		{
			prop: "policyType",
			label: "政策类型",
			type: "radio",
			istosee: true,
			radioval: comMapping.$sszskzclx,
		},
		{
			prop: "fabTime",
			label: "发文日期",
			type: "input",
			istosee: true
		},
	
		{
			prop: "implementTime",
			label: "施行日期",
			type: "input",
			istosee: true
		},
		{
			prop: "fbdanw",
			label: "发文机构",
			type: "input",
			istosee: true
		},
	],
	headDatazc: [
		{
			title: "标题",
			prop: "policyTitle",
			width: "200",
		},
		{
			title: "发文字号",
			prop: "policyNum",
			width: "200",
		},
		{
			title: "相关文档",
			prop: "policyFile",
			width: "200"
		},
		{
			title: "是否失效",
			prop: "isValid",
			width: "200",
			custom: true
		},
		{
			title: "政策类型",
			prop: "policyType",
			width: "150",
			custom: true
	
		},
		{
			title: "相关税种",
			prop: "xianggxz",
			width: "150"
		},
		{
			title: "发文日期",
			prop: "fabTime",
			width: "200"
		},
		{
			title: "施行日期",
			prop: "implementTime", width: "200"
		},
		{
			title: "发文机构",
			prop: "fbdanw",
			width: "200",
		},
	]
}
